import * as React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const reportItems = [{
  id: 1,
  text: "Baixo engajamento e taxas de conversão estagnadas"
}, {
  id: 2,
  text: "Custo por aquisição (CPA) acima da média do mercado"
}, {
  id: 3,
  text: "Dificuldade em escalar investimentos sem perder eficiência"
}, {
  id: 4,
  text: "Falta de clareza nos dados e métricas de acompanhamento"
}, {
  id: 5,
  text: "Criativos saturados que não conectam com o público-alvo"
}];
export default function WhatsIncludedInACreditReport() {
  return <section data-section-id="235505" id="problema" className="bg-background py-16 md:py-24 border-b border-[hsl(0,0%,90%)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div>
            <h2 className="font-default text-3xl font-bold text-foreground sm:text-4xl">
              Falta de resultado em campanhas
            </h2>
            <p className="mt-4 text-base text-[hsl(0,0%,35%)] leading-[1.6]">
              Muitas empresas investem em tráfego pago sem uma estratégia de conteúdo sólida, 
              resultando em orçamentos desperdiçados e leads desqualificados. O problema 
              não é a ferramenta, mas a falta de uma narrativa visual que converte.
            </p>

            <ul className="mt-8 space-y-4">
              {reportItems.map((item, i) => <li key={item.id} data-index={i} className="flex items-start gap-3">
                  <Check className="h-5 w-5 shrink-0 text-primary mt-0.5" />
                  <span className="text-base text-[hsl(0,0%,35%)]">
                    {item.text}
                  </span>
                </li>)}
            </ul>

            <div className="mt-10">
              <Button asChild size="lg" className="bg-primary text-primary-foreground rounded-full">
                <Link to="https://wa.me/5511969100007">Diagnosticar Minhas Campanhas</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/stagnant_digital_dashboard_analytics.png" alt="Painel de métricas digitais estagnado com cores naturais" className="w-full h-auto rounded-[12px] shadow-sm object-cover" />
          </div>
        </div>
      </div>
    </section>;
}